export enum StartrackingEventsNames {
  FilterApplied = "FILTER_APPLIED",

  // Inspiration page
  PreResultPageShown = "PRE_RESULT_PAGE_SHOWN",
  PreResultPageClicked = "PRE_RESULT_PAGE_CLICKED",

  // Hote List Page
  ResultClicked = "RESULT_CLICKED",
  ResultPageShown = "RESULT_PAGE_SHOWN",

  // Hotel Detail Page
  ProductDetailShown = "PRODUCT_DETAIL_SHOWN",
  ProductDetailClicked = "PRODUCT_DETAIL_CLICKED",
  ProductDetailPriceCalendarClicked = "PRODUCT_DETAIL_PRICE_CALENDAR_CLICKED",
  ProductDetailPriceCalendarOpenInteraction = "PRODUCT_DETAIL_PRICE_CALENDAR_OPEN_INTERACTION",
  ProductDetailPriceCalendarScrollingInteraction = "PRODUCT_DETAIL_PRICE_CALENDAR_SCROLLING_INTERACTION",
  CheckAvailability = "CHECK_AVAILABILITY",
  CheckUpsellingOptions = "CHECK_UPSELLING_OPTIONS",

  // Checkout Page
  CheckoutShown = "CHECKOUT_SHOWN",
  CheckoutClick2Pay = "CHECKOUT_CLICK2PAY", // TODO
  InsuranceReproposalShown = "INSURANCE_REPROPOSAL_SHOWN",
  InsuranceReproposalClicked = "INSURANCE_REPROPOSAL_CLICKED",
  InsuranceClicked = "INSURANCE_CLICKED",
  VoucherRedemptionResponse = "VOUCHER_REDEMPTION_RESPONSE",

  // Thank you page
  ThankYouPageShown = "THANK_YOU_PAGE_SHOWN",

  // Map (Result, Hotel Detail)
  MapClicked = "MAP_CLICKED",

  // AB Testing
  SaabChoice = "SAAB_CHOICE",
}
